import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import * as moment from 'moment';
import { Location } from '@angular/common';
import {StoreService} from 'src/stores/setting.store';
@Component({
  selector: 'app-ar-invoice',
  templateUrl: './ar-invoice.component.html',
  styleUrls: ['./ar-invoice.component.scss']
})
export class ArInvoiceComponent implements OnInit {

  reservationID;
  invoiceData = [];
  miscServices = [];
  passengers = [];
  flightInfo = [];
  activeTab;
  capitalOneVisibleOffer: boolean = false;
  capitalOneDiscount: number = 0;
  capitalOneBinNumbers: number[] = [];
  private notifier: NotifierService;
  constructor(private spinner: NgxSpinnerService,
    public location: Location,
    notifierService: NotifierService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private arService: ArService,
    private storeService: StoreService
  ) {
    this.notifier = notifierService;
    this.activeTab = this.route.snapshot.params.tid;

  }

  ngOnInit() {
    this.storeService.getSettingByKey('core::capitalOneVisibleOffer').subscribe(data => {
      try {
        this.capitalOneVisibleOffer = data ? JSON.parse(data) : false;
      } catch (e) {
        console.error('Error parsing capitalOneVisibleOffer:', e);
        this.capitalOneVisibleOffer = false;
      }
    });

    this.storeService.getSettingByKey('core::capitalOneDiscount').subscribe(data => {
      try {
        this.capitalOneDiscount = data ? JSON.parse(data) : 0;
      } catch (e) {
        console.error('Error parsing capitalOneDiscount:', e);
        this.capitalOneDiscount = 0;
      }
    });

    this.storeService.getSettingByKey('core::capitalOneBinNumbers').subscribe(data => {
      try {
        this.capitalOneBinNumbers = data ? JSON.parse(data) : [];
      } catch (e) {
        console.error('Error parsing capitalOneBinNumbers:', e);
        this.capitalOneBinNumbers = [];
      }
    });
    this.reservationID = this.route.snapshot.paramMap.get('id');
    localStorage.setItem('arCTActiveTab', this.activeTab);
    if (this.reservationID == '' || null) {
      this.onBack();
    }
    // this.getData();
    this.getAllInvoiceData();

  }

  getData() {
    this.arService.getInvoiceData(this.reservationID).subscribe(async res => {
      // this.spinner.hide();
      if (res['status']) {
        // this.notifier.notify('success', 'Payment method successfully submitted.');
        //  this.submitCCType = true;
        this.invoiceData = res['result'];
        // console.log(res);
        // setTimeout(r => {
        //   this.router.navigateByUrl("home/ar-dashboard");
        // },3000)

      } else {
        // this.notifier.notify('danger', 'Payment method Failed');
      }
    }, err => {
      // this.spinner.hide();
      // this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }

  subTotal = 0;
  getAllInvoiceData() {
    this.subTotal = 0;
    this.spinner.show();
    this.arService.getInvoicePassengersDataByResId(this.reservationID).subscribe(async res => {
      this.spinner.hide();
      if (res['status']) {
        // this.notifier.notify('success', 'Payment method successfully submitted.');
        //  this.submitCCType = true;
        this.invoiceData = res['result'].invoice;
        this.miscServices = res['result'].miscService;
        this.flightInfo = res['result'].flight;
        this.passengers = res['result'].passenger;
        // console.log(res);
        // setTimeout(r => {
        //   this.router.navigateByUrl("home/ar-dashboard");
        // },3000)

        for (let j of res['result'].miscService) {
          this.subTotal += (parseFloat(j.AMOUNT) * j.QUANTITY);

        }
        // console.log(this.subTotal, "SubTotal");

      } else {
        // this.notifier.notify('danger', 'Payment method Failed');
      }
    }, err => {
      this.spinner.hide();
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }

  onBack() {
    // this.router.navigateByUrl("home/ar-dashboard");
    this.location.back();
  }
  saveInvoicePrint() {
    // console.log('Calling....');
    const invoiceObj = {
      RESID: this.reservationID,
      PRINTED: 1,
      PRINTED_BY: this.authService.getCurrentUserId()
    }
    this.arService.updatePrintOfInvoice(invoiceObj).subscribe(async res => {
      if (res['status']) {
        //console.log(res['status']);
      } else {
        // console.log(res['message']);
      }
    }, err => {

      console.log(err);
    })
  }


  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }

  getDate(date) {
    return moment.utc(date).format('MMM DD, YYYY')
  }

  getTimeFormat(date) {
    if (date == null) {
      return '';
    }
    return moment.utc(date).format('MM/DD/YY, hh:mm a');
  }
  getDateFormat(date) {
    return moment.utc(date).format('MM/DD/YY');
  }

}
